/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';
import {
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSONTyped,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestToJSON,
} from './PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest';
import {
    PrtimesMediaListsMediaOutletsSearchRequestAllOf,
    PrtimesMediaListsMediaOutletsSearchRequestAllOfFromJSON,
    PrtimesMediaListsMediaOutletsSearchRequestAllOfFromJSONTyped,
    PrtimesMediaListsMediaOutletsSearchRequestAllOfToJSON,
} from './PrtimesMediaListsMediaOutletsSearchRequestAllOf';

/**
 * request of POST /prtimes_media_lists/media_outlets/search
 * @export
 * @interface PrtimesMediaListsMediaOutletsSearchRequest
 */
export interface PrtimesMediaListsMediaOutletsSearchRequest {
    /**
     * 検索キーワードのリスト
     * @type {Array<string>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    searchKeywords: Array<string>;
    /**
     * 配信方法のリスト
     * @type {Array<string>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    deliveryMethods: Array<PrtimesMediaListsMediaOutletsSearchRequestDeliveryMethodsEnum>;
    /**
     * メディア種類の子カテゴリIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 業種の親カテゴリのIDリスト。業種の子カテゴリは今の所メディアとの紐付けができるほど良い分類ができていないため業種については指定できるのは親カテゴリのみになる。
     * @type {Array<number>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    mediaIndustryGroupIds: Array<number>;
    /**
     * エリア（全国や東北、関東など）のidのリスト。今のところは全国が選択された時のみ使われるが他のエリアについても追加予定。
     * @type {Array<number>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    areaIds: Array<number>;
    /**
     * エリアの都道府県のIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    prefectureIds: Array<number>;
    /**
     * 発行部数/PVのリスト
     * @type {Array<MediaReach>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    reaches: Array<MediaReach>;
    /**
     * 機関誌かどうか
     * @type {boolean}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    isIncludeSpecialPublications: boolean;
    /**
     * 選択済みリストのメディアのIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    selectedMediaOutletIds: Array<number>;
    /**
     * 取得ページ番号(1から)。
     * @type {number}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    page?: number;
    /**
     * ページごとのアイテム数（デフォルトは100）
     * @type {number}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    perPage?: number;
    /**
     * ソート対象のフィールド名。値を指定しない場合、デフォルトのソート順はメディア種類IDの昇順、メディアIDの昇順になる。複数選択不可。
     * @type {string}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    sortField?: PrtimesMediaListsMediaOutletsSearchRequestSortFieldEnum;
    /**
     * ソート順。複数選択不可。
     * @type {string}
     * @memberof PrtimesMediaListsMediaOutletsSearchRequest
     */
    sortOrder?: PrtimesMediaListsMediaOutletsSearchRequestSortOrderEnum;
}

/**
* @export
* @enum {string}
*/
export enum PrtimesMediaListsMediaOutletsSearchRequestDeliveryMethodsEnum {
    Email = 'email',
    Fax = 'fax'
}/**
* @export
* @enum {string}
*/
export enum PrtimesMediaListsMediaOutletsSearchRequestSortFieldEnum {
    MediaType = 'media_type',
    AddedAt = 'added_at',
    Recommended = 'recommended',
    Popularity = 'popularity',
    Aiueo = 'aiueo'
}/**
* @export
* @enum {string}
*/
export enum PrtimesMediaListsMediaOutletsSearchRequestSortOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}

export function PrtimesMediaListsMediaOutletsSearchRequestFromJSON(json: any): PrtimesMediaListsMediaOutletsSearchRequest {
    return PrtimesMediaListsMediaOutletsSearchRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListsMediaOutletsSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsMediaOutletsSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchKeywords': json['search_keywords'],
        'deliveryMethods': json['delivery_methods'],
        'mediaTypeIds': json['media_type_ids'],
        'mediaIndustryGroupIds': json['media_industry_group_ids'],
        'areaIds': json['area_ids'],
        'prefectureIds': json['prefecture_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
        'isIncludeSpecialPublications': json['is_include_special_publications'],
        'selectedMediaOutletIds': json['selected_media_outlet_ids'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'perPage': !exists(json, 'per_page') ? undefined : json['per_page'],
        'sortField': !exists(json, 'sort_field') ? undefined : json['sort_field'],
        'sortOrder': !exists(json, 'sort_order') ? undefined : json['sort_order'],
    };
}

export function PrtimesMediaListsMediaOutletsSearchRequestToJSON(value?: PrtimesMediaListsMediaOutletsSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_keywords': value.searchKeywords,
        'delivery_methods': value.deliveryMethods,
        'media_type_ids': value.mediaTypeIds,
        'media_industry_group_ids': value.mediaIndustryGroupIds,
        'area_ids': value.areaIds,
        'prefecture_ids': value.prefectureIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
        'is_include_special_publications': value.isIncludeSpecialPublications,
        'selected_media_outlet_ids': value.selectedMediaOutletIds,
        'page': value.page,
        'per_page': value.perPage,
        'sort_field': value.sortField,
        'sort_order': value.sortOrder,
    };
}

